import { render, staticRenderFns } from "./Picture.vue?vue&type=template&id=55e38904&scoped=true"
import script from "./Picture.vue?vue&type=script&lang=js"
export * from "./Picture.vue?vue&type=script&lang=js"
import style0 from "./Picture.vue?vue&type=style&index=0&id=55e38904&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e38904",
  null
  
)

export default component.exports